$(function() {
	var amountScrolled = 300;
	if($('a.back-to-top').length > 0) {
	    $(window).scroll(function () {
	        if ($(window).scrollTop() > amountScrolled) {
	            $('a.back-to-top').fadeIn('slow');
	        } else {
	            $('a.back-to-top').fadeOut('slow');
	        }
	    });
	
	    $('a.back-to-top').click(function () {
	        $('body, html').animate({
	            scrollTop: 0
	        }, 700);
	        return false;
	    });
    	}
});